import ReactGA from 'react-ga';

const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || { type: 'Unknown' };

export function initialize(gaPropertyId) {
  ReactGA.initialize(gaPropertyId);
  ReactGA.plugin.require('ec');
}

export default function gaPush(
  hitType,
  {
    path,
    category,
    action,
    label,
    value,
    variable,
    name,
    price,
    lineItems,
    tax,
    revenue,
    id,
    affiliation,
    quantity,
  },
) {
  setCustomDimensions();
  switch (hitType) {
    case 'pageview':
      pageview(path);
      break;
    case 'event':
      event(category, action, label, value);
      break;
      case 'login':
      event(category, action, label, value);
     break;
    case 'add-sale-item':
      addSaleItem(name, price, quantity);
      break;
    case 'remove-sale-item':
      removeSaleItem(name, price, quantity);
      break;
    case 'checkout-sale':
      checkoutSale(lineItems);
      break;
    case 'complete-sale':
      completeSale(id, lineItems, tax, revenue, affiliation);
      break;
    case 'modal':
      modal(path);
      break;
    case 'timing':
      timing(category, variable, value, label);
      break;
    default:
  }
}

export function gaSetUser(user) {
  
  if (user) {
    ReactGA.set({
       userId: user.google_user_id,
       dimension5: user.opco_id
       });
  
  } else {
    ReactGA.set({
      dimension1: undefined,
    });
  }
}

export function gaSetCurrency(currencyCode) {
  ReactGA.set({
    currencyCode,
  });
}

function setCustomDimensions() {
  ReactGA.set({
    dimension2: process.env.REACT_APP_HEROKU_SLUG_COMMIT, // App revision
    dimension3: connection.type,                          // Connection type
  });
}

function pageview(path) {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
}

function event(category, action, label, value) {
  if (typeof value !== 'undefined') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } else {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
}
function checkoutSale(lineItems) {
  const location = window.location.href;
  let categoryName = 'Sale';
  if (location.indexOf('reports') >= 0) {
    categoryName = 'Report';
  } else if (location.indexOf('credit') >= 0) {
    categoryName = 'Ledger';
  }
  addProductsFromLineItems(lineItems);
  ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
    step: 1,
  });
  gaPush('event', { category: categoryName, action: 'Checkout', label: '' });
}

// Send 'purchase' and 'checkout' step 2 to GA
function completeSale(id, lineItems, tax, revenue, affiliation) {
  const location = window.location.href;
  let categoryName = 'Sale';
  if (location.indexOf('reports') >= 0) {
    categoryName = 'Report';
  } else if (location.indexOf('credit') >= 0) {
    categoryName = 'Ledger';
  }
  addProductsFromLineItems(lineItems);
  ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
    id,
    revenue,
    tax,
    affiliation,
  });
  gaPush('event', {
    category: categoryName,
    action: 'Create',
    value: (revenue * 100),
  });
  completeSaleReceipt(lineItems);
}

function completeSaleReceipt(lineItems) {
  const location = window.location.href;
  let categoryName = 'Sale';
  if (location.indexOf('reports') >= 0) {
    categoryName = 'Report';
  } else if (location.indexOf('credit') >= 0) {
    categoryName = 'Ledger';
  }
  addProductsFromLineItems(lineItems);
  ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
    step: 2,
  });
  gaPush('event', {
    category: categoryName,
    action: 'Complete',
  });
}

function addSaleItem(name, price, quantity) {
  const location = window.location.href;
  let categoryName = 'Sale';
  if (location.indexOf('reports') >= 0) {
    categoryName = 'Report';
  } else if (location.indexOf('credit') >= 0) {
    categoryName = 'Ledger';
  }
  ReactGA.plugin.execute('ec', 'addProduct', {
    name,
    price,
    quantity,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'add');
  gaPush('event', { category: categoryName, action: 'Add Product', label: name });
}

function removeSaleItem(name, price, quantity) {
  const location = window.location.href;
  let categoryName = 'Sale';
  if (location.indexOf('reports') >= 0) {
    categoryName = 'Report';
  } else if (location.indexOf('credit') >= 0) {
    categoryName = 'Ledger';
  }
  ReactGA.plugin.execute('ec', 'setAction', 'addProduct', {
    name,
    price,
    quantity,
  });
  ReactGA.plugin.execute('ec', 'setAction', 'remove');
  gaPush('event', { category: categoryName, action: 'Remove Product', name });
}

function modal(path) {
  ReactGA.modalview(path);
}

function timing(category, variable, value, label) {
  ReactGA.timing({
    category,
    variable,
    value,
    label,
  });
}

function addProductsFromLineItems(lineItems) {
  lineItems.forEach((lineItem) => {
    ReactGA.plugin.execute('ec', 'addProduct', {
      name: lineItem.product.name,
      price: lineItem.unitPrice || lineItem.total,
      quantity: lineItem.quantity || 1,
    });
  });
}
